<div class="list-page">
  <div>
    <h1>Kirjanpitäjä</h1>
  </div>

  @if (kirjanpitaja?.avain && kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px; margin-left: 20px">
      <h3 style="margin: 0 0 1em">Urit</h3>
      <div style="padding-left: 1em; padding-right: 1em">
        <div>
          Kirjanpitäjä (Lemonator): <a [href]="kirjanpitajaEncodedUriObservable | async" target="_BLANK">{{ kirjanpitajaUriObservable | async }}</a>
        </div>
      </div>
    </div>
  }

  <form (ngSubmit)="save()" novalidate>
    <div style="max-width: 450px">
      <mat-form-field>
        <mat-label>Etunimi</mat-label>
        <input #etunimiInput type="text" [formField]="lomake.etunimi" matInput />
        @if (naytaVirhe(lomake.etunimi, 'required')) {
          <mat-error> Etunimi puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Sukunimi</mat-label>
        <input type="text" [formField]="lomake.sukunimi" matInput />
        @if (naytaVirhe(lomake.sukunimi, 'required')) {
          <mat-error> Sukunimi puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Sähköpostiosoite</mat-label>
        <input type="text" [formField]="lomake.email" matInput />
        @if (naytaVirhe(lomake.email, 'required')) {
          <mat-error> Sähköpostiosoite puuttuu </mat-error>
        }
        @if (naytaVirhe(lomake.email, 'email')) {
          <mat-error> Sähköpostiosoite on virheellinen </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Puhelinnumero</mat-label>
        <input type="text" [formField]="lomake.puhelin" matInput />
        @if (naytaVirhe(lomake.puhelin, 'email')) {
          <mat-error> Puhelinnumero on virheellinen </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Aloitti</mat-label>
        <input type="text" [matDatepicker]="aloittiPicker" [formField]="lomake.aloitti" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="aloittiPicker"></mat-datepicker-toggle>
        <mat-datepicker #aloittiPicker startView="month"></mat-datepicker>
        @if (naytaVirhe(lomake.aloitti, 'required')) {
          <mat-error> Lisää sopimuksen aloitusaika </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Toimipiste</mat-label>
        <mat-select [formField]="lomake.toimipiste">
          @for (piste of kaikkiToimipisteet; track piste) {
            <mat-option [value]="piste.avain">
              {{ piste.nimi }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (kirjanpitajaOnDevaajaTaiTukiObservable | async) {
        <mat-form-field>
          <mat-label>Rooli</mat-label>
          <mat-select [formField]="lomake.rooli">
            <mat-option [value]="null">(ei roolia)</mat-option>
            <mat-option [value]="KirjanpitajanRooli.TAVALLINEN">Tavallinen</mat-option>
            <mat-option [value]="KirjanpitajanRooli.SUPER">Super</mat-option>
            <mat-option [value]="KirjanpitajanRooli.TAVALLINEN_JA_HOLVI">Tavallinen + Holvi</mat-option>
          </mat-select>
          <mat-hint>Muutos tulee voimaan, kun käyttäjä kirjautuu uudelleen sisään.</mat-hint>
        </mat-form-field>
      }
    </div>

    <div style="padding-top: 20px">
      <h3 style="margin-bottom: 10px; font-size: 16px; font-weight: 500">Tutkinnot</h3>
      <div style="color: grey; font-size: 12px">Huom! Ohjaa kirjanpitäjän allekirjoitusta, muotoiluna: 'Etunimi Sukunimi, KLT'</div>
      <div style="margin-left: 10px; margin-top: 15px">
        <mat-checkbox [formField]="lomake.tutkintoKlt">KLT</mat-checkbox>
      </div>
    </div>

    <div style="padding-top: 20px">
      <h3 style="margin-bottom: 10px; font-size: 16px; font-weight: 500">Aktiivisuus</h3>
      <div style="color: grey; font-size: 12px">Aktiivisesti tilitoimistossa työskentelevät kirjanpitäjät. Epäaktiivinen ei näy tiimi- ja vastuuvalinnoissa eikä voi kirjautua.</div>
      <div style="margin-left: 10px; margin-top: 15px">
        <mat-checkbox [formField]="lomake.aktiivinen">Aktiivinen</mat-checkbox>
      </div>
    </div>

    <div style="padding-top: 20px">
      <h3 style="margin-bottom: 10px; font-size: 16px; font-weight: 500">Sallitut näkymät</h3>
      <div style="color: grey; font-size: 12px; margin-bottom: 10px">Jos yhtään näkymää ei ole valittuna, kirjanpitäjä näkee kaikki näkymät. Vastuukirjanpitäjä näkee aina kaikki asiakkaan näkymät.</div>
      <div style="margin-bottom: 10px">
        <app-secondary-button (click)="valitseKaikkiNakymat()" actionId="Valitse kaikki näkymät" styles="margin-right: 10px;">Valitse kaikki</app-secondary-button>
        <app-secondary-button (click)="poistaKaikkiNakymat()" actionId="Poista kaikki näkymät">Poista kaikki</app-secondary-button>
      </div>
      @for (ryhma of nakymaRyhmat; track ryhma.ryhma) {
        <div style="margin-bottom: 15px">
          <div style="font-weight: 500; margin-bottom: 5px">{{ ryhma.ryhma }}</div>
          @for (nakyma of ryhma.nakymat; track nakyma.avain) {
            <div style="margin-left: 10px">
              <mat-checkbox [checked]="onkoNakymaValittu(nakyma.avain)" (change)="toggleNakyma(nakyma.avain, $event.checked)">
                {{ nakyma.nimi }}
              </mat-checkbox>
            </div>
          }
        </div>
      }
    </div>
  </form>

  @if (commonError()) {
    <div class="error-text">
      {{ commonError() }}
    </div>
  }

  <div style="max-width: 450px">
    <div style="display: flex; justify-content: space-evenly; margin-top: 1em; margin-bottom: 2em">
      <app-secondary-button (click)="peruuta()" actionId="Peruuta (kirjanpitäjän tiedot)">{{ 'yleiset.peruuta' | translate | async }}</app-secondary-button>
      <app-primary-button (click)="save()" actionId="Tallenna kirjanpitäjän tiedot" [actionContext]="[lomake().value()]">{{ 'yleiset.tallenna' | translate | async }}</app-primary-button>
    </div>
  </div>

  <div>Allekirjoitus, suomi:</div>
  <div #signature app-kirjanpito-lahetys-signature [kirjanpitajanNimitiedot]="kirjanpitaja" kieli="fi"></div>

  <div>Allekirjoitus, englanti:</div>
  <div #signature app-kirjanpito-lahetys-signature [kirjanpitajanNimitiedot]="kirjanpitaja" kieli="en"></div>

  <div class="drag-drop-area" style="max-width: 450px">
    <app-file-drop #droppi dropZoneClassName="kuva-container" (onFileOver)="fileOver()" (onFileLeave)="fileLeave()" (onFileDrop)="fileDrop($event)" (click)="fileInput.click()" class="droppi" style="cursor: pointer">
      <ng-template app-file-drop-content-tmp>
        <div style="padding: 3em">Vedä kirjanpitäjän kuva tähän tai klikkaa</div>
      </ng-template>
    </app-file-drop>
  </div>
  @if (kuvanVirhe) {
    <div class="error-box">{{ kuvanVirhe }}</div>
  }

  @if (donePercentageObservable) {
    <mat-progress-bar mode="determinate" [value]="donePercentageObservable | async"></mat-progress-bar>
  }

  <button class="secondarybutton" mat-button (click)="katkaiseLemonatorSessio()">Katkaise Lemonator sessio</button>
</div>
<input #fileInput type="file" style="visibility: hidden" accept="image/*" (change)="lataa($event)" />
